// extracted by mini-css-extract-plugin
module.exports = {"popupFieldComponent":"Claims_popupFieldComponent__z6v-1","contactDetailsLink":"Claims_contactDetailsLink__7M-on"};